var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "menu-options" }, [
    _c("div", { staticClass: "md-layout" }, [
      !_vm.isSales
        ? _c(
            "div",
            {
              staticClass:
                "md-layout-item md-xsmall-size-100 md-medium-size-100",
            },
            [
              _c("router-link", { attrs: { to: "/map/" } }, [
                _c("div", { staticClass: "box-container first-box" }, [
                  _c("div", [
                    _c(
                      "div",
                      [
                        _c("md-icon", { staticClass: "dashboard-icon" }, [
                          _vm._v("travel_explore"),
                        ]),
                      ],
                      1
                    ),
                    _c("div", [_c("span", [_vm._v("Track your team")])]),
                    _c(
                      "div",
                      { staticClass: "navigate-arrow" },
                      [_c("md-icon", [_vm._v("navigate_next")])],
                      1
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm.isSales
        ? _c(
            "div",
            {
              staticClass:
                "md-layout-item md-xsmall-size-100 md-medium-size-100",
            },
            [
              _c("router-link", { attrs: { to: "/customers/list" } }, [
                _c("div", { staticClass: "box-container" }, [
                  _c("div", [
                    _c(
                      "div",
                      [
                        _c("md-icon", { staticClass: "dashboard-icon" }, [
                          _vm._v("contact_page"),
                        ]),
                      ],
                      1
                    ),
                    _c("div", [_c("span", [_vm._v("Customers")])]),
                    _c(
                      "div",
                      { staticClass: "navigate-arrow" },
                      [_c("md-icon", [_vm._v("navigate_next")])],
                      1
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "md-layout-item md-xsmall-size-100 md-medium-size-100" },
        [
          _c("router-link", { attrs: { to: "/stops/list" } }, [
            _c("div", { staticClass: "box-container" }, [
              _c("div", [
                _c(
                  "div",
                  [
                    _c("md-icon", { staticClass: "dashboard-icon" }, [
                      _vm._v("place"),
                    ]),
                  ],
                  1
                ),
                _c("div", { staticClass: "manage-stops" }, [
                  _c("span", [_vm._v("Manage your stops")]),
                ]),
                _c(
                  "div",
                  { staticClass: "navigate-arrow" },
                  [_c("md-icon", [_vm._v("navigate_next")])],
                  1
                ),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "md-layout-item md-xsmall-size-100 md-medium-size-100" },
        [
          _c("router-link", { attrs: { to: "/shipments/list" } }, [
            _c("div", { staticClass: "box-container" }, [
              _c("div", [
                _c(
                  "div",
                  [
                    _c("md-icon", { staticClass: "dashboard-icon" }, [
                      _vm._v("local_shipping"),
                    ]),
                  ],
                  1
                ),
                _c("div", [_c("span", [_vm._v("Shipments")])]),
                _c(
                  "div",
                  { staticClass: "navigate-arrow" },
                  [_c("md-icon", [_vm._v("navigate_next")])],
                  1
                ),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "md-layout-item md-xsmall-size-100 md-medium-size-100" },
        [
          _c("router-link", { attrs: { to: "/trips/list" } }, [
            _c("div", { staticClass: "box-container" }, [
              _c("div", [
                _c(
                  "div",
                  [
                    _c("md-icon", { staticClass: "dashboard-icon" }, [
                      _vm._v("commute"),
                    ]),
                  ],
                  1
                ),
                _c("div", [_c("span", [_vm._v("Trips")])]),
                _c(
                  "div",
                  { staticClass: "navigate-arrow" },
                  [_c("md-icon", [_vm._v("navigate_next")])],
                  1
                ),
              ]),
            ]),
          ]),
        ],
        1
      ),
      !_vm.isSales
        ? _c(
            "div",
            {
              staticClass:
                "md-layout-item md-xsmall-size-100 md-medium-size-100",
            },
            [
              _c("router-link", { attrs: { to: "/customers/list" } }, [
                _c("div", { staticClass: "box-container" }, [
                  _c("div", [
                    _c(
                      "div",
                      [
                        _c("md-icon", { staticClass: "dashboard-icon" }, [
                          _vm._v("contact_page"),
                        ]),
                      ],
                      1
                    ),
                    _c("div", [_c("span", [_vm._v("Customers")])]),
                    _c(
                      "div",
                      { staticClass: "navigate-arrow" },
                      [_c("md-icon", [_vm._v("navigate_next")])],
                      1
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }